import ajax from "../../authenticationSafeAjax";

export const UPTAKE_REPORT_DATA_RECIVED = "UPTAKE_REPORT_DATA_RECIVED";
export const COLUMN_SORTED = "COLUMN_SORTED";

export function uptakeReportDataRecived(payload) {
    return {
        type: UPTAKE_REPORT_DATA_RECIVED,
        payload
    }
}

export function columnSorted(payload) {
    return {
        type: COLUMN_SORTED,
        payload
    }
}

export function loadUptakeReportData() {
    return (dispatch, getState) => {
        ajax({
            url: "/recorder/api/uptake-report",
            method: "GET"
        }, (statusCode, text, request) => {
            dispatch(uptakeReportDataRecived(JSON.parse(text)));
        })
    }
}


/** WEBPACK FOOTER **
 ** ./src/main/javascript/compliance/uptake/reportingActions.js
 **/